import { ISection } from '@/typings';
import { adaptDecimalValueToPercentage } from '../utilities';
import { SectionResponseDTO } from '@/api/section/DTOs';

export const adaptSectionResponseToSection = (
  sectionResponse: SectionResponseDTO,
): ISection => {
  const fieldSummary = sectionResponse.fieldsSummary;
  return {
    id: sectionResponse.sectionID,
    title: sectionResponse.title,
    requiredFieldsCount: fieldSummary?.requiredFieldsCount ?? 0,
    fieldsCount: fieldSummary?.fieldsCount ?? 0,
    pendingRequiredFieldsCount: fieldSummary?.pendingRequiredFieldsCount ?? 0,
    pendingFieldsCount: fieldSummary?.pendingFieldsCount ?? 0,
    restrictionViolationsCount: fieldSummary?.restrictionViolationsCount ?? 0,
    completedPercentage: adaptDecimalValueToPercentage(
      fieldSummary?.completedPercentage ?? 0,
    ),
    instructions: sectionResponse.instructions,
    estimatedWorkRemainingInMinutes:
      sectionResponse.estimatedWorkRemainingInMinutes,
    requiredDocuments: sectionResponse.requiredDocuments,
    validationMessages: sectionResponse.validationMessages,
  };
};
